<section class="content">
  <div class="d-flex justify-content-center align-items-center min-vh-100">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-10">
        <div class="card card-primary">
          <div class="card-header text-center">
            <h3 class="card-title">OTP Verification</h3>
          </div>
          <div class="card-body">
            <div class="d-flex justify-content-center">
              <img
                [src]="brand.logoUrl"
                [alt]="brand.companyName"
                class="logo-image mb-3" />
            </div>
            <p>Please type the one-time password to verify your account.</p>
            <form class="otp-form">
              <ng-otp-input
                class="d-flex justify-content-center"
                (onInputChange)="onOtpChange($event)"
                [config]="{
                  length: 6,
                  inputStyles: { width: '50px', height: '50px' }
                }"></ng-otp-input>
              <div class="form-group mt-3">
                <button
                  (click)="verifyOtp()"
                  [disabled]="otp.length !== 6 || isVerifying"
                  class="btn btn-primary custom-button">
                  <ng-container *ngIf="isVerifying; else submitText">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"></span>
                  </ng-container>
                </button>
                <ng-template #submitText>Verify</ng-template>
              </div>
              <p
                class="verification-message text-danger mt-2"
                *ngIf="verificationMessage">
                {{ verificationMessage }}
              </p>
            </form>
          </div>
          <div class="card-footer text-end">
            <div class="resend-container">
              <span *ngIf="isResendDisabled" class="text-muted ms-2">
                ({{ resendTimer }} seconds remaining)
              </span>
              <button
                [disabled]="isResendDisabled"
                type="button"
                class="btn btn-link p-0"
                (click)="resendOtp()">
                Resend OTP
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
